import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Container,
  Typography,
  Box,
  Button,
  Stack,
  Paper,
  Divider
} from '@mui/material'
import ApprovedAccountInfo from 'pages/AccountDetail/ApprovedAccountInfo'
import PendingAccountInfo from 'pages/AccountDetail/PendingAccountInfo'
import ApproveUserForm from 'pages/AccountDetail/ApproveUserForm'
import RejectUserForm from 'pages/AccountDetail/RejectUserForm'
import TableLoading from 'components/TableLoading'
import { ApprovedAccount, PendingAccount } from 'types/accountTypes'
import NotFoundPage from 'pages/NotFound'
import { AccountStatus, useAccounts } from 'hooks/useAccounts'

const AccountDetailPage = () => {
  const { accountId } = useParams<{ accountId: string }>()
  const navigate = useNavigate()
  const { currentAccount, isLoading, error, fetchAccountById } = useAccounts()

  useEffect(() => {
    if (accountId) {
      fetchAccountById(accountId)
    }
  }, [accountId])

  if (isLoading)
    return (
      <Container sx={{ py: 4 }}>
        <TableLoading />
      </Container>
    )
  if (error)
    return (
      <Container sx={{ py: 4 }}>
        <Typography color='error'>{error}</Typography>
      </Container>
    )
  if (!accountId || !currentAccount?.account) return <NotFoundPage />

  const { account, accountStatus } = currentAccount
  const isApproved = accountStatus === AccountStatus.APPROVED
  return (
    <Container sx={{ py: 4 }}>
      {isApproved ? (
        <>
          <ApprovedAccountInfo data={account as ApprovedAccount} />
          <Box mt={2}>
            <Button variant='outlined' onClick={() => navigate(-1)}>
              Back
            </Button>
          </Box>
        </>
      ) : (
        <>
          <PendingAccountInfo data={account as PendingAccount} />
          <Paper elevation={2} sx={{ mt: 3, p: 3, borderRadius: 2 }}>
            <Typography variant='h6' gutterBottom>
              Manage Pending Account
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={4}
              alignItems='flex-start'
            >
              <Box flex={1}>
                <ApproveUserForm data={account as PendingAccount} />
              </Box>
              <Box flex={1}>
                <RejectUserForm accountId={account.id} />
              </Box>
            </Stack>
          </Paper>
          <Box mt={2}>
            <Button variant='outlined' onClick={() => navigate(-1)}>
              Back
            </Button>
          </Box>
        </>
      )}
    </Container>
  )
}

export default AccountDetailPage
